export default __webpack_public_path__ + "static/media/warning.ee42a63e.svg";